module.exports = __webpack_public_path__ + "static/media/chrome-lock.fe7ea603.png";